__turbopack_context__.v({
  "landingPage": "landing-page-module__QVANTq__landingPage",
});
